export default "__VITE_ASSET__85728baf__"